import type { Subcontractor } from "./types";

export const SUBCONTRACTOR_OPTIONS: Subcontractor[] = ["ABB", "Heijndijk", "SWAP"];

/**
 * Deliberately soft/muted — lower saturation than the phase and status colors, so a
 * subcontractor tag reads as "whose work is this" rather than competing as another
 * alarm color on the card.
 */
export const DEFAULT_SUBCONTRACTOR_COLORS: Record<string, string> = {
  ABB: "#8a8fb0",
  Heijndijk: "#a06a95",
  SWAP: "#b3775a",
};

export function subcontractorColor(colors: Record<string, string>, name: string): string {
  return colors[name] ?? DEFAULT_SUBCONTRACTOR_COLORS[name] ?? "#9a9890";
}

/**
 * The color picker offers exactly these swatches rather than a free-form input, shared
 * between subcontractor tags and swimlane colors (see PhasesModal). Chosen by greedy
 * farthest-point sampling in CIE Lab space so all 25 stay maximally distinguishable
 * from each other at a glance on a crowded board, with the one hard constraint that
 * each stays legible under the fixed dark tag text (contrast >= 4.5:1 against #0b0b0b,
 * see `.sticky-tag.subc` in app.css) — no longer tied to an actual Post-it® paper color.
 */
export const TAG_COLORS: { name: string; hex: string }[] = [
  { name: "Ember Orange", hex: "#ff8f1f" },
  { name: "Electric Violet", hex: "#c31fff" },
  { name: "Signal Green", hex: "#1fff1f" },
  { name: "Cyan Blue", hex: "#1fd2ff" },
  { name: "Hot Pink", hex: "#ff1f80" },
  { name: "Lime Mist", hex: "#d5f7a1" },
  { name: "Royal Blue", hex: "#2f75ee" },
  { name: "Blush Pink", hex: "#ffc2d0" },
  { name: "Pure Yellow", hex: "#f5f500" },
  { name: "Crimson Red", hex: "#f50021" },
  { name: "Orchid Pink", hex: "#f47bec" },
  { name: "Teal Spring", hex: "#00f5d4" },
  { name: "Terracotta", hex: "#cd6251" },
  { name: "Forest Green", hex: "#37be45" },
  { name: "Olive Gold", hex: "#bea337" },
  { name: "Periwinkle", hex: "#a8abf0" },
  { name: "Seafoam", hex: "#cbf6ec" },
  { name: "Chartreuse", hex: "#afff47" },
  { name: "Peach", hex: "#ffcc99" },
  { name: "Rose Pink", hex: "#f47bab" },
  { name: "Magenta", hex: "#f500d4" },
  { name: "Mint Green", hex: "#1fffa5" },
  { name: "Lavender Violet", hex: "#a970ff" },
  { name: "Moss Green", hex: "#9abe37" },
  { name: "Amber Gold", hex: "#ffcb1f" },
];
